/*
 * useAuditPanel3.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-10-13 in huWaWi3 33.1.0
 * Copyright (c) 2021, 2023 HUDORA GmbH
 */

import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import React, { ReactElement, useCallback, useState } from 'react'

import { IEntity } from '../../types'
import { useHdPanel } from '../../WaWi/components/HdPanel'
import { AuditLog } from '../components/AuditLog'
import { HdAuditIcon } from '../components/HdIcons'
import { TusePanelReturn } from './hookTypes'

export function useAuditPanel3({
  designator,
  entity,
  defaultName = '',
}: { designator?: string; entity?: IEntity; defaultName?: string } = {}): TusePanelReturn {
  const [designator2, setDesignator] = useState(designator)
  const { openDialog, renderDialog } = useHdPanel(`Änderungsverfolgung ${designator || defaultName}`.trim())
  const [entity2, setEntity] = useState<IEntity>(entity)

  const myOpenPanel = useCallback(
    (eNew?: IEntity, dNew?: string): void => {
      dNew && setDesignator(dNew)
      eNew && setEntity(eNew)
      if (!dNew && eNew) {
        setDesignator(`${eNew.designator}`)
      }
      openDialog()
    },
    [openDialog]
  )

  const renderOpenButton = useCallback(
    (e?: IEntity): ReactElement => (
      <IconButton size="small" color="primary" title="Änderungsverfolgung" onClick={() => myOpenPanel(e)}>
        <HdAuditIcon />
      </IconButton>
    ),
    [openDialog]
  )

  const auditItem: ICommandBarItemProps = {
    key: 'auditPanel3',
    text: 'Änderungsverfolgung',
    ariaLabel: 'Änderungsverfolgung',
    iconOnly: true,
    iconProps: { iconName: 'Memo' },
    // buttonAs
    // onRender(item: any, dismissMenu: (ev?: any, dismissAll?: boolean) => void)
    onClick: () => openDialog(),
  }

  const dialog = renderDialog({
    renderBody: () => (
      <Box>
        <AuditLog forDesignator={designator2} entity={entity2} />
      </Box>
    ),
  })

  return [auditItem, dialog, myOpenPanel, renderOpenButton]
}
